/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    initialQueryState,
    PaginationState,    
    stringifyRequestQuery,
    WithChildren,
    Response
} from '../../../../../_metronic/helpers'

import { getDLMThresholds } from '../_requests'
import { DLMThresholdListItem } from '../_models'
import { useDLMThresholdQueryRequest } from './DLMThresholdQueryRequestProvider'
import { useAuth } from '../../../auth'


const DLMThresholdQueryResponseContext = createResponseContext<DLMThresholdListItem>(initialQueryResponse)
const DLMThresholdQueryResponseProvider: FC<WithChildren> = ({children}) => {
    const {state} = useDLMThresholdQueryRequest()
    const {currentUser} = useAuth();

    const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
    const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
    
    useEffect(() => {        
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        ['DLMTHRESHOLD-LIST'],        
        // @ts-ignore
        () => {               
            if (currentUser && currentUser.role === 'System Admin') {
                // dummy response for 'System Admin' only accounts
                return Promise.resolve().then(() => {
                    return {data : [] , payload : {}};
                })
            } else { 
                return getDLMThresholds();
            }            
        },
        {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
    )

    return (
    <DLMThresholdQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
        {children}
    </DLMThresholdQueryResponseContext.Provider>
    )
}

const useDLMThresholdQueryResponse = () => useContext(DLMThresholdQueryResponseContext)

const useDLMThresholdQueryResponseData = () => {
    const {response} = useDLMThresholdQueryResponse()
    if (!response) {
        return []
    }

    return response?.data || []
}

const useDLMThresholdQueryResponsePagination = () => {
    const defaultPaginationState: PaginationState = {
        links: [],
        ...initialQueryState,
    }

  const {response} = useDLMThresholdQueryResponse()
    if (!response || !response.payload || !response.payload.pagination) {
        return defaultPaginationState
    }

    return response.payload.pagination
}

const useDLMThresholdQueryResponseLoading = (): boolean => {
  const {isLoading} = useDLMThresholdQueryResponse()
  return isLoading
}

export {
    DLMThresholdQueryResponseProvider,
    useDLMThresholdQueryResponse,
    useDLMThresholdQueryResponseData,
    useDLMThresholdQueryResponsePagination,
    useDLMThresholdQueryResponseLoading,
}


export type DLMThresholdQueryResponse = Response<Array<DLMThresholdListItem>>